import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type Suggestion from 'src/types/Suggestion';

export interface RAOReportLogFilterState {
  repositorySuggestion: Suggestion[],
  repositoryChosen: string | null;
}

const initialState: RAOReportLogFilterState = {
  repositorySuggestion: null,
  repositoryChosen: ''
};

interface RAOReportAction {
  repositorySuggestion: Suggestion[],
  repositoryChosen: Suggestion[],
}
const slice = createSlice({
  name: 'RAOReportLogFilter',
  initialState,
  reducers: {
    setRAOReportLogFilter(
      state: RAOReportLogFilterState,
      action: PayloadAction<RAOReportAction>
    ) {
      const {
        repositorySuggestion,
      } = action.payload;
      state.repositorySuggestion = repositorySuggestion;
      state.repositoryChosen = '';
    },
    resetRAOReportLogFilter(
      state: RAOReportLogFilterState,
    ) {
      state.repositoryChosen = initialState.repositoryChosen;
    },
    changeRepositoryChosen(
      state: RAOReportLogFilterState,
      action: PayloadAction<string>
    ) {
      state.repositoryChosen = action.payload;
    }
  }
});

export const { reducer } = slice;

export const {
  resetRAOReportLogFilter,
  setRAOReportLogFilter,
  changeRepositoryChosen
} = slice.actions;

export default slice;
